module.exports = function drawPineapple(ctx) {
  ctx.save();
  ctx.fillStyle = 'rgba(0, 0, 0, 0)';
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(10, 0);
  ctx.lineTo(10, 18);
  ctx.lineTo(0, 18);
  ctx.closePath();
  ctx.clip();
  ctx.translate(0, 0);
  ctx.translate(0, 0);
  ctx.scale(1, 1);
  ctx.translate(0, 0);
  ctx.strokeStyle = 'rgba(0,0,0,0)';
  ctx.lineCap = 'butt';
  ctx.lineJoin = 'miter';
  ctx.miterLimit = 4;
  ctx.save();
  ctx.fillStyle = '#30b1ad';
  ctx.beginPath();
  ctx.moveTo(6.11825, 2.02539);
  ctx.lineTo(6.20481, 2.02539);
  ctx.bezierCurveTo(7.04304, 1.62736, 7.96487, 1.67407, 7.96487, 1.67407);
  ctx.bezierCurveTo(7.96487, 1.67407, 8.01484, 2.70413, 7.54526, 3.57965);
  ctx.bezierCurveTo(8.5318, 3.53457, 9.3597, 3.80379, 9.3597, 3.80379);
  ctx.bezierCurveTo(9.3597, 3.80379, 8.9221, 5.83394, 7.43903, 6.6916);
  ctx.bezierCurveTo(6.66501, 7.13921, 5.7592, 7.17899, 5.06998, 7.11472);
  ctx.bezierCurveTo(4.38077, 7.17899, 3.47496, 7.13921, 2.70094, 6.6916);
  ctx.bezierCurveTo(1.21787, 5.83394, 0.780273, 3.80379, 0.780273, 3.80379);
  ctx.bezierCurveTo(0.780273, 3.80379, 1.47642, 3.57741, 2.35268, 3.57459);
  ctx.bezierCurveTo(1.886, 2.70016, 1.93577, 1.67407, 1.93577, 1.67407);
  ctx.bezierCurveTo(1.93577, 1.67407, 2.85761, 1.62736, 3.69583, 2.02539);
  ctx.lineTo(3.82874, 2.02539);
  ctx.bezierCurveTo(4.00905, 0.878398, 4.97137, 0, 4.97137, 0);
  ctx.bezierCurveTo(4.97137, 0, 5.93553, 0.878398, 6.11825, 2.02539);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.fillStyle = '#febe40';
  ctx.beginPath();
  ctx.moveTo(0.00976562, 10.1031);
  ctx.bezierCurveTo(0.00976562, 7.34674, 2.2442, 5.1123, 5.00051, 5.1123);
  ctx.bezierCurveTo(7.75683, 5.1123, 9.99126, 7.34674, 9.99126, 10.1031);
  ctx.lineTo(9.99126, 13.009);
  ctx.bezierCurveTo(9.99126, 15.7653, 7.75683, 17.9997, 5.00051, 17.9997);
  ctx.bezierCurveTo(2.2442, 17.9997, 0.00976562, 15.7653, 0.00976562, 13.009);
  ctx.lineTo(0.00976562, 10.1031);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.fillStyle = '#ea676c';
  ctx.globalAlpha = 0.5;
  ctx.beginPath();
  ctx.moveTo(5.14964, 5.11426);
  ctx.lineTo(5.00019, 5.2648);
  ctx.lineTo(4.85078, 5.1143);
  ctx.bezierCurveTo(4.60407, 5.12158, 4.36184, 5.14673, 4.12534, 5.18851);
  ctx.lineTo(4.60064, 5.66725);
  ctx.lineTo(3.50221, 6.77366);
  ctx.lineTo(2.51099, 5.77523);
  ctx.bezierCurveTo(2.34322, 5.87176, 2.18159, 5.97774, 2.02681, 6.09245);
  ctx.lineTo(3.10266, 7.17611);
  ctx.lineTo(2.00376, 8.283);
  ctx.lineTo(0.93292, 7.20438);
  ctx.bezierCurveTo(0.820201, 7.36181, 0.716392, 7.52604, 0.622231, 7.69635);
  ctx.lineTo(1.6042, 8.68546);
  ctx.lineTo(0.50529, 9.79235);
  ctx.lineTo(0.0596837, 9.34351);
  ctx.bezierCurveTo(
    0.022153,
    9.58677,
    0.00215694,
    9.83583,
    0.00102726,
    10.0893
  );
  ctx.lineTo(0.105736, 10.1948);
  ctx.lineTo(0.000976562, 10.3003);
  ctx.lineTo(0.000976562, 11.1052);
  ctx.lineTo(0.505291, 10.5973);
  ctx.lineTo(1.60371, 11.7037);
  ctx.lineTo(0.504802, 12.8106);
  ctx.lineTo(0.000976562, 12.3031);
  ctx.lineTo(0.000976562, 12.9995);
  ctx.bezierCurveTo(
    0.000976562,
    13.0362,
    0.00137076,
    13.0727,
    0.00215515,
    13.1092
  );
  ctx.lineTo(0.105247, 13.213);
  ctx.lineTo(0.0103723, 13.3086);
  ctx.bezierCurveTo(0.0251066, 13.5502, 0.0570003, 13.7872, 0.10485, 14.0183);
  ctx.lineTo(0.504802, 13.6155);
  ctx.lineTo(1.60469, 14.7234);
  ctx.lineTo(0.731405, 15.603);
  ctx.bezierCurveTo(0.831923, 15.7675, 0.94168, 15.9257, 1.05995, 16.077);
  ctx.lineTo(2.00424, 15.1258);
  ctx.lineTo(3.10266, 16.2322);
  ctx.lineTo(2.1997, 17.1417);
  ctx.bezierCurveTo(2.36066, 17.2508, 2.52832, 17.3507, 2.70192, 17.4408);
  ctx.lineTo(3.50222, 16.6347);
  ctx.lineTo(4.60112, 17.7416);
  ctx.lineTo(4.38261, 17.9617);
  ctx.bezierCurveTo(4.58522, 17.9867, 4.7916, 17.9995, 5.00098, 17.9995);
  ctx.bezierCurveTo(5.21017, 17.9995, 5.41637, 17.9867, 5.61882, 17.9617);
  ctx.lineTo(5.40023, 17.7416);
  ctx.lineTo(6.49914, 16.6347);
  ctx.lineTo(7.29964, 17.441);
  ctx.bezierCurveTo(7.47326, 17.3509, 7.64092, 17.251, 7.8019, 17.142);
  ctx.lineTo(6.8987, 16.2322);
  ctx.lineTo(7.99761, 15.1253);
  ctx.lineTo(8.94217, 16.0767);
  ctx.bezierCurveTo(9.06044, 15.9255, 9.17019, 15.7672, 9.27069, 15.6027);
  ctx.lineTo(8.39716, 14.7229);
  ctx.lineTo(9.49607, 13.616);
  ctx.lineTo(9.89683, 14.0196);
  ctx.bezierCurveTo(9.94473, 13.7886, 9.97669, 13.5516, 9.99149, 13.3101);
  ctx.lineTo(9.89562, 13.2135);
  ctx.lineTo(9.99981, 13.1086);
  ctx.bezierCurveTo(10.0006, 13.0723, 10.001, 13.036, 10.001, 12.9995);
  ctx.lineTo(10.001, 12.3025);
  ctx.lineTo(9.49607, 12.8111);
  ctx.lineTo(8.39716, 11.7042);
  ctx.lineTo(9.49558, 10.5978);
  ctx.lineTo(10.001, 11.1068);
  ctx.lineTo(10.001, 10.3019);
  ctx.lineTo(9.89514, 10.1953);
  ctx.lineTo(10.0009, 10.0887);
  ctx.bezierCurveTo(9.99976, 9.83526, 9.97974, 9.58623, 9.94219, 9.34299);
  ctx.lineTo(9.49558, 9.79285);
  ctx.lineTo(8.39716, 8.68644);
  ctx.lineTo(9.37986, 7.6966);
  ctx.bezierCurveTo(9.28571, 7.52628, 9.18191, 7.36204, 9.0692, 7.20461);
  ctx.lineTo(7.99761, 8.28399);
  ctx.lineTo(6.89772, 7.17611);
  ctx.lineTo(7.97424, 6.09178);
  ctx.bezierCurveTo(7.81943, 5.9771, 7.65776, 5.87115, 7.48997, 5.77465);
  ctx.lineTo(6.49817, 6.77366);
  ctx.lineTo(5.39974, 5.66725);
  ctx.lineTo(5.87527, 5.18827);
  ctx.bezierCurveTo(5.63872, 5.14655, 5.39642, 5.12146, 5.14964, 5.11426);
  ctx.closePath();
  ctx.moveTo(3.90177, 7.17611);
  ctx.lineTo(5.00019, 6.06971);
  ctx.lineTo(6.09861, 7.17611);
  ctx.lineTo(5.00019, 8.28252);
  ctx.lineTo(3.90177, 7.17611);
  ctx.closePath();
  ctx.moveTo(5.39974, 8.68497);
  ctx.lineTo(6.49817, 7.57857);
  ctx.lineTo(7.59805, 8.68644);
  ctx.lineTo(6.49963, 9.79285);
  ctx.lineTo(5.39974, 8.68497);
  ctx.closePath();
  ctx.moveTo(6.89918, 10.1953);
  ctx.lineTo(7.99761, 9.0889);
  ctx.lineTo(9.09603, 10.1953);
  ctx.lineTo(7.99761, 11.3017);
  ctx.lineTo(6.89918, 10.1953);
  ctx.closePath();
  ctx.moveTo(2.00327, 11.3012);
  ctx.lineTo(0.904844, 10.1948);
  ctx.lineTo(2.00376, 9.08791);
  ctx.lineTo(3.10218, 10.1943);
  ctx.lineTo(2.00327, 11.3012);
  ctx.closePath();
  ctx.moveTo(3.50173, 9.79186);
  ctx.lineTo(2.40331, 8.68546);
  ctx.lineTo(3.50221, 7.57857);
  ctx.lineTo(4.60064, 8.68497);
  ctx.lineTo(3.50173, 9.79186);
  ctx.closePath();
  ctx.moveTo(3.90129, 10.1943);
  ctx.lineTo(5.00019, 9.08743);
  ctx.lineTo(6.10007, 10.1953);
  ctx.lineTo(5.00117, 11.3022);
  ctx.lineTo(3.90129, 10.1943);
  ctx.closePath();
  ctx.moveTo(5.40073, 11.7046);
  ctx.lineTo(6.49963, 10.5978);
  ctx.lineTo(7.59805, 11.7042);
  ctx.lineTo(6.49915, 12.811);
  ctx.lineTo(5.40073, 11.7046);
  ctx.closePath();
  ctx.moveTo(6.8987, 13.2135);
  ctx.lineTo(7.99761, 12.1066);
  ctx.lineTo(9.09651, 13.2135);
  ctx.lineTo(7.99761, 14.3204);
  ctx.lineTo(6.8987, 13.2135);
  ctx.closePath();
  ctx.moveTo(6.49915, 13.616);
  ctx.lineTo(7.59805, 14.7229);
  ctx.lineTo(6.49914, 15.8297);
  ctx.lineTo(5.40024, 14.7229);
  ctx.lineTo(6.49915, 13.616);
  ctx.closePath();
  ctx.moveTo(5.00068, 15.1253);
  ctx.lineTo(6.09959, 16.2322);
  ctx.lineTo(5.00068, 17.3391);
  ctx.lineTo(3.90177, 16.2322);
  ctx.lineTo(5.00068, 15.1253);
  ctx.closePath();
  ctx.moveTo(4.60113, 14.7229);
  ctx.lineTo(3.50222, 15.8298);
  ctx.lineTo(2.40379, 14.7234);
  ctx.lineTo(3.50271, 13.6165);
  ctx.lineTo(4.60113, 14.7229);
  ctx.closePath();
  ctx.moveTo(3.10315, 13.214);
  ctx.lineTo(2.00424, 14.3209);
  ctx.lineTo(0.904356, 13.213);
  ctx.lineTo(2.00327, 12.1061);
  ctx.lineTo(3.10315, 13.214);
  ctx.closePath();
  ctx.moveTo(3.50271, 12.8115);
  ctx.lineTo(2.40282, 11.7037);
  ctx.lineTo(3.50173, 10.5968);
  ctx.lineTo(4.60162, 11.7046);
  ctx.lineTo(3.50271, 12.8115);
  ctx.closePath();
  ctx.moveTo(3.90226, 13.214);
  ctx.lineTo(5.00117, 12.1071);
  ctx.lineTo(6.09959, 13.2135);
  ctx.lineTo(5.00068, 14.3204);
  ctx.lineTo(3.90226, 13.214);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.restore();
};
